import { toArray } from 'lodash-es';
import omit from 'lodash-es/omit';

export const SUB_NAV_SECTIONS_MAP = {
  Pricing: {
    name: 'Pricing',
    hash: 'edm-comparator-pricing',
  },
  'Edmunds Rating': {
    name: 'Edmunds rating',
    hash: 'edm-comparator-edmunds-rating',
  },
  'Consumer Rating': {
    name: 'Consumer rating',
    hash: 'edm-comparator-consumer-rating',
  },
  Warranty: {
    name: 'Warranty',
    hash: 'edm-comparator-warranty',
  },
  Features: {
    name: 'Features',
    hash: 'edm-comparator-features',
  },
  Specifications: {
    name: 'Specifications',
    hash: 'edm-comparator-specifications',
  },
  'Fuel economy': {
    name: 'Fuel economy',
    hash: 'edm-comparator-fuel-economy',
  },
  Battery: {
    name: 'Battery',
    hash: 'edm-comparator-battery',
    isEvItem: true,
  },
  Dimensions: {
    name: 'Dimensions',
    hash: 'edm-comparator-dimensions',
  },
  '5-Year Ownership Costs': {
    name: 'Ownership costs',
    hash: 'edm-comparator-ownership-costs',
  },
  Colors: {
    name: 'Colors',
    hash: 'edm-comparator-colors',
  },
};

export const SUB_NAV_SECTIONS_LIST = toArray(SUB_NAV_SECTIONS_MAP);
export const TRIMS_SUB_NAV_SECTIONS_LIST = {
  // used
  true: toArray(omit(SUB_NAV_SECTIONS_MAP, ['Edmunds Rating', 'Consumer Rating', 'Warranty', 'Pricing'])),
  // new
  false: toArray(omit(SUB_NAV_SECTIONS_MAP, ['Edmunds Rating', 'Consumer Rating', 'Warranty'])),
};
